export enum PRICE_TEXT_SURFACE {
  PRODUCT_TILE = "product_tile",
  PDP = "pdp",
  QUICK_ADD_MODAL = "quick_add_modal",
  BRAND = "brand",
}

export interface IPriceTextProps {
  originalPrice: string;
  wholesalePrice: string;
  retailPrice: string;
  isUKRetailer: boolean;
  isLoggedInOrBrandPreview: boolean;
  showProductPromotions: boolean;
  small?: boolean;
  isOutOfStock?: boolean;
  showOutOfStockUnderProductName?: boolean;
  isTilePricing?: boolean;
  priceTextSurface?: PRICE_TEXT_SURFACE;
}
